module.exports = __webpack_public_path__ + "static/media/school-profile-banner1.bfa92d83.jpg";